<template>
  <div v-if="this.fieldEdited">
    <div :id="this.content.path" contenteditable="true" spellcheck="true" class="content-input"
          @blur="contentBlurred" v-html="editedContent()" @focus="contentFocused"
          :style="{ borderColor: borderColor, backgroundColor: backgroundColor }"></div>
    <b-tooltip :disabled.sync="showOriginalText" :target="this.content.path" placement="topright" triggers="focus">
      <strong>Original Text</strong>
      <div v-if="this.content.original_value && this.content.original_value.trim() === ''">
        N/A
      </div>
      <div v-else>
        {{ this.content.original_value }}
        <br> <strong>Modified By</strong> <br>
        {{ this.content.edited_by }}
      </div>
    </b-tooltip>
    <b-popover v-if="hidePopOver"
              :target="this.content.path" placement="top" triggers="focus" boundary="window">
      <div class="canvas-wrapper">
        <canvas :id="'canvas_' + this.content.path"></canvas>
      </div>
    </b-popover>
  </div>
  <div v-else>
    <div :id="this.content.path" contenteditable="true" spellcheck="true" class="content-input"
          @focus="contentFocused" @blur="contentBlurred"
          :style="{ borderColor: borderColor, backgroundColor: backgroundColor }">
      <span v-for="word in this.content.ocr_text && this.content.ocr_text.words">
        <span v-if="word['characters']" >
          <span v-for="character in word['characters']">
            <span v-if="isNewLine(character['letter'])"><br/></span>
            <span :style="{color: setColor(character)}" v-else>{{ character['letter'] }}</span>
          </span>
        </span>
        <span v-else>
          <span>{{ word['text'] + " "}}</span>
        </span>
      </span>
    </div>
    <b-popover v-if="hidePopOver" :target="this.content.path" placement="top" triggers="focus" boundary="window">
      <div class="canvas-wrapper">
        <canvas :id="'canvas_' + this.content.path"></canvas>
      </div>
    </b-popover>
  </div>
</template>

<script>
export default {
  props: ['content', 'imgBase', 'imgUrl', 'currentPage', 'docStatus'],
  data () {
    return {
      showOriginalText: this.content.key === 'Plain Text'
    }
  },
  computed: {
    fieldEdited: function () {
      return this.content.edited
    },
    borderColor: function () {
      return this.fieldEdited ? '#170c9e' : this.content.color_code
    },
    hidePopOver: function () {
      if (this.docStatus === 'unmatched' || this.docStatus === 'unmatched_accepted') {
        return false
      }
      if (this.content.path.split('.')[0] === this.currentPage.toString()) {
        return true
      }
    },
    backgroundColor: function () {
      return this.content.invalid ? '#F8CECD' : null
    }
  },
  methods: {
    isNewLine: function (letter) {
      return letter === '\n'
    },

    editedContent: function () {
      let html = ''
      for (let letter of this.content.current_value) {
        if (this.isNewLine(letter)) {
          html += '<span><br /></span>'
        } else {
          html += '<span>' + letter + '</span>'
        }
      }
      return html
    },
    showFieldCanvas: function (imageBase, imageUrl, path) {
      let { x_pos: x, y_pos: y, width, height } = this.content
      var canvas = document.getElementById('canvas_' + path)
      height = Math.ceil(height) + 1
      if (height / 50 > 4) {
        canvas.parentElement.style.maxHeight = '100px'
        canvas.style.maxHeight = height / 4 + 'px'
      } else {
        canvas.parentElement.style.maxHeight = '75px'
        canvas.style.maxHeight = '50px'
      }
      canvas.width = width
      canvas.height = height
      var image = new window.Image()
      image.src = imageBase + imageUrl
      var ctx = canvas.getContext('2d')
      image.onload = function () {
        ctx.drawImage(image, x, y, width, height, 0, 0, width, height)
      }
    },
    setColor: function (character) {
      if (this.fieldEdited) { return null }
      return character['score'] <= 0.60 ? '#f86c6b' : '#3e515b'
    },

    contentFocused: function (event) {
      if (this.docStatus === 'unmatched' || this.docStatus === 'unmatched_accepted') {
        return
      }
      if (this.content.path.split('.')[0] === this.currentPage.toString()) {
        this.$emit('focused', this.content.path)
        this.showFieldCanvas(this.imgBase, this.imgUrl, this.content.path)
      }
    },
    contentBlurred: function (event) {
      let newValue = event.target.innerText === '\n' ? '' : event.target.innerText
      if (newValue !== this.content.current_value) {
        this.content.current_value = newValue
        this.$emit('update', {content: this.content, newValue: newValue})
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.content-input {
  padding: 0.375rem 0.75rem;
  color: #3e515b;
  border: 1px solid #d1d4d7;
  max-height: 200px;
  overflow-y: auto;
}

.canvas-wrapper {
  max-width: 200px;
  padding: 5px;
  overflow: auto;
}

::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: rgb(183, 184, 185);
    -webkit-box-shadow: 0 0 1px rgba(255,255,255,.5);
}
</style>


// WEBPACK FOOTER //
// src/components/utils/contentEditable.vue